import { HomePage, AboutPage } from './pages';

export const routes = {
  '/': {
    index: 0,
    text: 'Home',
    icon: 'home',
    enabled: true,
    component: HomePage
  },
  '/about': {
    index: 1,
    text: 'About',
    icon: 'about',
    enabled: true,
    component: AboutPage
  },
  '/contact': {
    index: 1,
    text: 'Contact',
    icon: 'contact',
    enabled: false,
    component: AboutPage
  }
};

